module.exports = __webpack_public_path__ + "static/media/client_16.60ce37fe.png";